// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"e8da7973995e4a0f","3433":"b5b175eb41821d31","3707":"b5b175eb41821d31"}[chunkId] + ".css";
};